var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container-fluid"},[_c('uspCartao',{attrs:{"titulo":"Configurações","fechavel":false}},[_c('template',{slot:"corpo"},[_c('uspAcordeao',{attrs:{"itens":_vm.itens}})],1)],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }